
import angular from 'angular';
import clinkManagerModule from '../angular_apps/clink_manager/scripts/app';

import { angular2react } from 'angular2react';

import 'bootstrap';
import 'tooltip.js';
import 'popper.js';
import '../angular_apps/clink_manager/scripts/controllers/clinks-main';
import { useEffect, useState } from 'react';
import jQuery from 'jquery';
import { PagesHelper } from '../common/PagesHelper';
import { useAbortController } from '../hooks/useAbortController';
import { TrafficSources } from '../services/TrafficSources';
let $injector:any;

const clinkManagerAngularComponent = {
  bindings: {
    currentUser: '<'
  },
  templateUrl: './clink_manager/views/main/main.html',
  controller: 'MainCtrl'
}

// Expose components to Angular
clinkManagerModule
  .run(['$injector', function (_$injector:any) { $injector = _$injector }])
  .component('clinkManager', clinkManagerAngularComponent);

angular.bootstrap(document.createElement('div'), ['clinkManager'], { strictDi: true });
let ClinkManager:any = angular2react('clinkManager', clinkManagerAngularComponent, $injector);

function TrackingLinksLookupPage(props : any) {
  const [currentUser, setCurrentUser] = useState(props.currentUser);
  const { createController } = useAbortController();

  if (props.currentUser && props.currentUser !== currentUser) {
    ClinkManager = angular2react('clinkManager', clinkManagerAngularComponent, $injector);
    setCurrentUser(props.currentUser);
  }

  useEffect(() => {
    jQuery("body").tooltip({ selector: ".ngdialog [title]", trigger: "hover", delay: { "show": 250, "hide": 100 } });
    jQuery("#clink-manager-container").tooltip({ selector: "[title]", trigger: "hover", delay: { "show": 250, "hide": 100 } });
  }, [] );
  useEffect(() => {
    if (props.currentUser) {
      const controller = createController();
      
      // Load both demand sources and traffic sources
      Promise.all([
        PagesHelper.loadDemandSourcesHelper(controller),
        TrafficSources.getTrafficSources(controller)
      ]).then(() => {
        // Notify AngularJS that both demand sources and traffic sources have loaded
        window.dispatchEvent(new CustomEvent('demandSourcesLoaded'));
        window.dispatchEvent(new CustomEvent('trafficSourcesLoaded'));
      });
    }
  }, [props.currentUser, createController]);

  return (
    <div id="tracking-links-lookup-container" style={{ paddingTop: "15px", fontSize: "0.875rem" }}>
      <ClinkManager currentUser={props.currentUser} />
    </div>
  );
}

export default TrackingLinksLookupPage;